import { Expose, Type } from "class-transformer";
import { ValidateNested } from "class-validator";
import { Admin } from "../../entity";

export class GetAllAdminDTO {
  @Expose()
  @ValidateNested()
  @Type(() => Admin)
  users!: Admin[];
}
